import React from 'react';
import {Box, Typography} from '@mui/material';
import {CampaignFilledRounded} from '@mui-symbols-material/w300';
import {useTranslation} from 'react-i18next';

interface Props {
    message: string;
}

const SystemAnnouncementToast = ({message}: Props) => {
    const {t} = useTranslation();

    return (
        <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 1.5, padding: '2px 0'}}>
            <Box
                sx={{
                    backgroundColor: 'primary.main',
                    color: '#fff',
                    borderRadius: '50%',
                    width: 44,
                    height: 44,
                    minWidth: 44,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <CampaignFilledRounded sx={{fontSize: 28}}/>
            </Box>
            <Box>
                <Typography variant="subtitle2" sx={{fontWeight: 700, color: '#333', lineHeight: '20px'}}>
                    {t('Announcement')}
                </Typography>
                <Typography variant="body2" sx={{color: '#333', whiteSpace: 'pre-line'}}>
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};

export default SystemAnnouncementToast;
